import Vue from 'vue';
import store from './store';
import vuexI18n from 'vuex-i18n';
import Vuex, { Store } from 'vuex';
import VueRouter from 'vue-router';
import PortalVue from 'portal-vue';

import App from './components/events-submissions/App.vue';
import ViewEvent from './components/events-submissions/ViewEvent.vue';
import EventAuthentication from "./components/events-submissions/EventAuthentication.vue";

import {initializeChildListener} from '@open-iframe-resizer/core';
initializeChildListener();

import "~/style/forms.css"; 
import "~/style/events.css";
import ApiService from "./lib/api";
import {ModalState} from "./store/context";

Vue.use(PortalVue);
Vue.use(Vuex);
Vue.use(VueRouter);

Vue.use(vuexI18n.plugin, store);
Vue.i18n.set('en_US');

const routes = [
  {path: '/view/events', name: 'view-events', component: App},
  {
    path: '/view/events/authenticate',
    name: 'authenticate',
    components: {eventView: EventAuthentication}
  },
  {path: '/view/events/:id', name: 'view-event', components: {eventView: ViewEvent}},
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

interface setupOptions {
  /**
   * The element to mount the Vue app to.
   */
  element: string;
  /**
   * The API URL to use with no trailing slash.
   */
  apiUrl: string;
}


export default function setupEntrySubmissions(options: setupOptions): void {
  new Vue({
    store: store as Store<any>,
    router,
    render(createElement) {
      /**
       * @deprecated kept for previous embeddings of the events with the old iframe-resizer.com library.
       */
      const load = setInterval(() => {
        if ('parentIFrame' in window) {
          clearInterval(load);
          (window as any).parentIFrame.setHeightCalculationMethod('taggedElement');
          (window as any).parentIFrame.getPageInfo((e: any) => {
            this.$store.dispatch('context/setIframeOffsetY', e.scrollTop - e.offsetTop);
          });
        }
      },100);

      // Dimensions reported from the parent when resizing occurs.
      let parentIframeBox: DOMRect = new DOMRect(0, 0, 0, 0);
      window.addEventListener('message', (e) => {
        if (e.data.type === 'authenticate') {
          this.$store.dispatch('context/createScopedSession', e.data.token);
        }

        if (e.data.type === 'parentScroll') {
          this.$store.dispatch('context/setIframeOffsetY', e.data.offsetY);
        }

        if (e.data.type === 'resize') {
          parentIframeBox = e.data.dimensions;
        }
      });

      /**
       * Watch to see when modals are opened/closed to inform the parent window for resizing.
       */
      this.$store.subscribe(({type, payload}: {type: string, payload: ModalState}) => {
        if (type === 'context/setModalState') {
          if (!payload.open) {
            document.body.style.height = 'auto';
            return;
          }

          let offset = this.$store.getters['context/iframeOffsetY'];
          // Add extra padding to make sure it is rendered in full and ignore negative offsets.
          const bottom = payload.height + (offset < 0 ? 0 : offset) + 100;
          document.body.style.height = bottom > parentIframeBox.height ? `${bottom}px` : document.body.style.height;

          // Send the position of the open modal so we can try and focus it for the user when it opens.
          window.parent.postMessage({type: 'iframe-modal-state', state: payload}, '*');
        }
      });

      ApiService.init(options.apiUrl);
      this.$store.dispatch('context/readBrowserToken');

      return createElement(App);
    },
  }).$mount(options.element);
}
